module.exports = [
  "getVersion", "getNetworkType", "getContactList", "pickContact",
  "getRequestId", "getDeviceInfo", "clearStorage", "store", "retrieve", "publish", "subscribe", "unsubscribe", "openScheme", "jumpToScheme", "closeWindow", "sendSMS",
  "downloadImage", "setBackgroundColor", "setTitle", "setLLButton", "setLRButton", "setRLButton", "setRRButton", "isInstalledApp",
  "alert", "prompt", "confirm", "actionSheet"
];


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp-core/lib/apis.js
// module id = 535
// module chunks = 0